export const FETCH_GRADES = "FETCH_GRADES";
export const FETCH_AIRPORTS = "FETCH_AIRPORTS";
export const FETCH_AIRLINES = "FETCH_AIRLINES";
export const SET_GRADES = "SET_GRADES";
export const SET_AIRPORTS_DATA = "SET_AIRPORTS_DATA";
export const SET_AIRLINES = "SET_AIRLINES";
export const SET_COUNTRY_CODE_LIST = "SET_COUNTRY_CODE_LIST";
